export enum DateSourceModel {
    EVENT = 'Event_Date',
    SITE = 'Site_Date',
    STATE = 'State_Date',
}
